import { render, staticRenderFns } from "./customMomentTemplateDetails.vue?vue&type=template&id=5ea1c7f0&"
import script from "./customMomentTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./customMomentTemplateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports